<template>
  <el-select
    ref="select"
    :value="value_id"
    v-bind="selectProps"
    v-on="selectOn"
    @clear="clearHandle"
  >
    <el-input v-model="filter_text" placeholder="输入关键字进行过滤" />
    <el-option :value="value_id" :label="value_name">
      <el-tree
        id="tree-option"
        ref="selectTree"
        class="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.value"
        :show-checkbox="ischeckbox"
        highlight-current
        :default-expand-all="false"
        :filter-node-method="filterNode"
        :render-content="renderContent"
        @node-click="handleNodeClick"
        @check="handleNodeChckeClick"
      />
    </el-option>
  </el-select>
</template>
<script>
const ValuePropsType = () => {
  return [Number, Array];
};
export default {
  name: 'SelectTree',
  props: {
    /* 配置项 */
    props: {
      type: Object,
      default: () => {
        return {
          value: 'id', // ID字段名
          label: 'name', // 显示名称
          children: 'children', // 子级字段名
        };
      },
    } /* 选项列表数据(树形结构的对象数组) */,
    /* 选择框属性*/
    selectProps: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /* 选择框事件*/
    selectOn: {
      type: Object,
      default: () => {
        return {};
      },
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /* 初始值 */
    value: {
      type: new ValuePropsType(),
      default: () => {
        return null;
      },
    },
    /* 自动收起 */
    accordion: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    /* 是否多选*/
    ischeckbox: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    /** 是否严格的遵守父子节点不互相关联 */
    checkStrictly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // 过滤值
      filter_text: '',
      value_id: null, // 初始值
      value_name: '',
      value_ids: [],
    };
  },
  watch: {
    // 绑定值
    value() {
      if (this.value_ids.length > 0) {
        this.value_ids = this.value;
      } else {
        this.value_id = this.value;
      }
      if (this.value === null || this.value.length === 0) {
        this.value_name = '';
      }
      this.initHandle();
    },

    // 过滤
    filter_text(val) {
      this.$refs.selectTree.filter(val);
    },
  },
  mounted() {
    if (this.value && this.value.length > 0) {
      this.value_ids = this.value;
    }
    this.initHandle();
  },
  methods: {
    // 初始化值
    initHandle() {
      this.$nextTick(() => {
        if (this.value_id && this.options.length) {
          this.value_name = this.$refs.selectTree.getNode(this.value_id).data[
            this.props.label
          ];
          // 初始化显示
          this.$refs.selectTree.setCurrentKey(this.value_id); // 设置默认选中
        }

        // 多选回显
        if (this.value_ids?.length && this.options?.length) {
          this.$refs.selectTree.setCheckedKeys(this.value_ids);
          const check_nodes = this.$refs.selectTree.getCheckedNodes(!this.checkStrictly);
          this.value_name = check_nodes.map(check_node => check_node[this.props.label]).join('、');
        }

        const scrollWrap = document.querySelectorAll(
          '.el-scrollbar .el-select-dropdown__wrap'
        )[0];
        const scrollBar = document.querySelectorAll(
          '.el-scrollbar .el-scrollbar__bar'
        );
        scrollWrap.style.cssText =
          'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach((ele) => (ele.style.width = 0));
      });
    },

    /**
     * 切换选项
     * @param node 节点所对应的对象
     */
    handleNodeClick(node) {
      if (!this.ischeckbox) {
        // 选择后关闭
        this.$refs.select.blur();
        this.value_name = node[this.props.label];
        this.value_id = node[this.props.value];
        this.$emit('getValue', this.value_id, this.value_name, node?.jrtt_app_id, node?.gdt_app_id);
        this.defaultExpandedKey = [];
      }
    },

    handleNodeChckeClick(node, flag) {
      if (!this.checkStrictly) {
        const check_nodes = this.getCheckedNodes(this.$refs.selectTree.store);
        const check_keys = check_nodes.map(check_node => check_node[this.props.value]);
        this.value_name = check_nodes.map(check_node => check_node[this.props.label]).join('、');
        this.value_ids = check_keys;
        this.$emit('getcheckedValue', this.value_ids);
        return;
      }

      if (this.ischeckbox) {
        this.value_name = '';
        flag.checkedNodes.forEach((item, index) => {
          this.value_name += `${item.name},  `;
        });
        this.value_ids = flag.checkedKeys;
        this.$emit('getcheckedValue', this.value_ids);
        this.defaultExpandedKey = [];
      }
    },

    /**
     * 获取选中的节点
     * @param {Object} store el-tree的store数据
     * @returns {Object}
     */
    getCheckedNodes(store) {
      const checkedNodes = [];
      const traverse = (node) => {
        const childNodes = node.root ? node.root.childNodes : node.childNodes;
        childNodes.forEach(child => {
          if (child.checked) {
            // 全选仅返回子节点
            if (!this.checkStrictly && child.childNodes.length) {
              child.childNodes.forEach(child_nodes_item => {
                if (child_nodes_item.childNodes.length) {
                  traverse(child_nodes_item);
                } else {
                  checkedNodes.push(child_nodes_item.data);
                }
              });
            } else {
              // 全选返回父节点
              checkedNodes.push(child.data);
            }
          }
          if (child.indeterminate) {
            traverse(child);
          }
        });
      };
      traverse(store);
      return checkedNodes;
    },

    // 清除选中
    clearHandle() {
      this.value_name = '';
      this.value_id = null;
      this.value_ids = [];
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit('getValue', null);
      this.$emit('getcheckedValue', null);
    },

    // 清空选中样式
    clearSelected() {
      const allNode = document.querySelectorAll('#tree-option .el-tree-node');
      allNode.forEach((element) => element.classList.remove('is-current'));
    },
    // 渲染游戏id
    renderContent(h, { node, data, store }) {
      return (
        <span>
          {node.data.id} {node.label}
        </span>
      );
    },

    // 过滤
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data[this.props.label].indexOf(value) !== -1 || data[this.props.value] === parseInt(value);
    },
  },
};
</script>
<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 10px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
.selectTree >>> .el-tree-node__expand-icon {
  font-size: 19px !important;
}
</style>

